import React from 'react';

import { IconCash } from '@lightspeed/flame/Icon/Cash';
import { IconClock } from '@lightspeed/flame/Icon/Clock';
import { IconContent } from '@lightspeed/flame/Icon/Content';
import { IconCustomers } from '@lightspeed/flame/Icon/Customers';
import { IconEcomAm } from '@lightspeed/flame/Icon/EcomAm';
import { IconGiftcard } from '@lightspeed/flame/Icon/Giftcard';
import { IconHome } from '@lightspeed/flame/Icon/Home';
import { IconInventory } from '@lightspeed/flame/Icon/Inventory';
import { IconRegister } from '@lightspeed/flame/Icon/Register';
import { IconSettings } from '@lightspeed/flame/Icon/Settings';
import { IconShop } from '@lightspeed/flame/Icon/Shop';
import { IconStatistics } from '@lightspeed/flame/Icon/Statistics';
import { IconSubscription } from '@lightspeed/flame/Icon/Subscription';
import { IconTools } from '@lightspeed/flame/Icon/Tools';

export const iconToSectionMap = (section: TSFixMe) => {
  let icon;
  switch (section) {
    case 'home':
      icon = <IconHome />;
      break;
    case 'register':
    case 'sales':
    case 'current sale':
    case 'switch registers':
      icon = <IconRegister />;
      break;
    case 'inventory':
    case 'items':
      icon = <IconInventory />;
      break;
    case 'gift cards':
      icon = <IconGiftcard />;
      break;
    case 'service':
    case 'workorder: new':
    case 'workorder':
      icon = <IconTools />;
      break;
    case 'customers':
      icon = <IconCustomers />;
      break;
    case 'ecom':
      icon = <IconEcomAm />;
      break;
    case 'subscription':
      icon = <IconSubscription />;
      break;
    case 'reports':
      icon = <IconStatistics />;
      break;
    case 'financial services':
      icon = <IconCash />;
      break;
    case 'settings':
      icon = <IconSettings />;
      break;
    case 'system':
      icon = <IconContent />;
      break;
    case 'switch shops':
    case 'shop':
      icon = <IconShop />;
      break;
    case 'clock in or out':
      icon = <IconClock />;
      break;
    case 'nuorder':
      icon = <img height={16} width={16} alt="NuOrder" src="https://d2o5po5b88zacb.cloudfront.net/dist/assets/lshash-118c0e2/images/b2b/nuorder-black-icon.svg" />;
      break;
    default:
  }

  return icon;
};
